import { useReducer } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import PrivateRoute from "../routes/PrivateRoutes";
import { initialAuth, authReducer } from "../reducer/auth";
import { initialAlert, alertReducer } from "../reducer/alert";
import { initialLoading, loadingReducer } from "../reducer/loading";
import { AuthContext, AlertContext, LoadingContext } from "../context/index";

import Login from "./auth/Login";
import Home from "./views/home/Home";
import AlertBox from "./common/AlertBox";
import LoadingBox from "./common/LoadingBox";

import { CLIENTS, OPERATIONS } from "../constants/value";

import Pause from "./views/base/Pause";
import Refill from "./views/base/Refill";
import Restore from "./views/base/Restore";
import Unpause from "./views/base/Unpause";
import Activate from "./views/base/Activate";
import ChangePlan from "./views/base/ChangePlan";
import Deactivate from "./views/base/Deactivate";
import ChangeNumber from "./views/base/ChangeNumber";
import ChangeSimBatchList from "./views/base/ChangeSimBatchList";

import ActivateForm from "./views/Ultra/Activate/ActivateForm";
import ActivateBatch from "./views/Ultra/Activate/ActivateBatch";
import ActivateUpdate from "./views/Ultra/Activate/ActivateUpdate";
import ActivateHistory from "./views/Ultra/Activate/ActivateHistory";

import ChangeNumberForm from "./views/Ultra/ChangeNumber/ChangeNumberForm";
import ChangeNumberBatch from "./views/Ultra/ChangeNumber/ChangeNumberBatch";
import ChangeNumberUpdate from "./views/Ultra/ChangeNumber/ChangeNumberUpdate";
import ChangeNumberHistory from "./views/Ultra/ChangeNumber/ChangeNumberHistory";

import PauseForm from "./views/Ultra/Pause/PauseForm";
import PauseBatch from "./views/Ultra/Pause/PauseBatch";
import PauseHistory from "./views/Ultra/Pause/PauseHistory";

import DeactivateForm from "./views/Ultra/Deactivate/DeactivateForm";
import DeactivateBatch from "./views/Ultra/Deactivate/DeactivateBatch";
import DeactivateHistory from "./views/Ultra/Deactivate/DeactivateHistory";

import RestoreForm from "./views/Ultra/Restore/RestoreForm";
import RestoreBatch from "./views/Ultra/Restore/RestoreBatch";
import RestoreHistory from "./views/Ultra/Restore/RestoreHistory";

import SimInfo from "./views/base/SimInfo";
import SimInfoForm from "./views/Ultra/SimInfo/SimInfoForm";
import SimInfoBatch from "./views/Ultra/SimInfo/SimInfoBatch";

import UltraEsim from "./views/Ultra/Esim/Esim";
import EsimForm from "./views/Ultra/Esim/EsimForm";

import TelitActivateForm from "./views/Telit/Activate/ActivateForm";
import TelitActivateBatch from "./views/Telit/Activate/ActivateBatch";
import TelitActivateHistory from "./views/Telit/Activate/ActivateHistory";

import TelitDeactivateForm from "./views/Telit/Deactivate/DeactivateForm";
import TelitDeactivateBatch from "./views/Telit/Deactivate/DeactivateBatch";
import TelitDeactivateHistory from "./views/Telit/Deactivate/DeactivateHistory";

import TelitChangeNumberForm from "./views/Telit/ChangeNumber/ChangeNumberForm";
import TelitChangeNumberBatch from "./views/Telit/ChangeNumber/ChangeNumberBatch";
import TelitChangeNumberHistory from "./views/Telit/ChangeNumber/ChangeNumberHistory";

import ChangePlanForm from "./views/Ultra/ChangePlan/ChangePlanForm";
import ChangePlanBatch from "./views/Ultra/ChangePlan/ChangePlanBatch";
import ChangePlanHistory from "./views/Ultra/ChangePlan/ChangePlanHistory";

import TmobilejExportList from "./views/Tmobilej/SimInfo/TmobilejExportList";
import TelitExportList from "./views/Telit/SimInfo/TelitExportList";
import TelitChangePlanForm from "./views/Telit/ChangePlan/ChangePlanForm";
import TelitChangePlanBatch from "./views/Telit/ChangePlan/ChangePlanBatch";
import TelitChangePlanHistory from "./views/Telit/ChangePlan/ChangePlanHistory";

import ZipCheckList from "./views/Ultra/SimInfo/ZipChecks";
import ZipCheckForm from "./views/Ultra/SimInfo/ZipCheckForm";

import UnpauseForm from "./views/Ultra/Unpause/UnpauseForm";
import UnpauseBatch from "./views/Ultra/Unpause/UnpauseBatch";
import UnpauseHistory from "./views/Ultra/Unpause/UnpauseHistory";

import SparqActivateForm from "./views/Sparq/Activate/ActivateForm";
import SparqActivateBatch from "./views/Sparq/Activate/ActivateBatch";
import SparqActivateHistory from "./views/Sparq/Activate/ActivateHistory";

import SparqDeactivateForm from "./views/Sparq/Deactivate/DeactivateForm";
import SparqDeactivateBatch from "./views/Sparq/Deactivate/DeactivateBatch";
import SparqDeactivateHistory from "./views/Sparq/Deactivate/DeactivateHistory";

import CricketActivateForm from "./views/Cricket/Activate/ActivateForm";
import CricketActivateHistory from "./views/Cricket/Activate/ActivateHistory";
import CricketActivateBatch from "./views/Cricket/Activate/ActivateBatch";

import VerizonActivateForm from "./views/Verizon/Activate/ActivateForm";
import VerizonActivateHistory from "./views/Verizon/Activate/ActivateHistory";
import VerizonActivateBatch from "./views/Verizon/Activate/ActivateBatch";

import CricketRefillForm from "./views/Cricket/Refill/RefillForm";
import CricketRefillHistory from "./views/Cricket/Refill/RefillHistory";
import CricketRefillBatch from "./views/Cricket/Refill/RefillBatch";

import VerizonRefillForm from "./views/Verizon/Refill/RefillForm";
import VerizonRefillHistory from "./views/Verizon/Refill/RefillHistory";
import VerizonRefillBatch from "./views/Verizon/Refill/RefillBatch";

import TelitPauseForm from "./views/Telit/Pause/PauseForm";
import TelitPauseBatch from "./views/Telit/Pause/PauseBatch";
import TelitPauseHistory from "./views/Telit/Pause/PauseHistory";

import CredentialForm from "./views/Ultra/CredentialForm";
import TelitCredentialForm from "./views/Telit/CredentialForm";
import SparqCredentialForm from "./views/Sparq/CredentialForm";
import VerizonCredentialForm from "./views/Verizon/CredentialForm";
import CricketCredentialForm from "./views/Cricket/CredentialForm";

import Portin from "./views/base/Portin";
import PortinForm from "./views/Ultra/Portin/PortinForm";
import PortinHistory from "./views/Ultra/Portin/PortinHistory";
import PortinBatch from "./views/Ultra/Portin/PortinBatch";
import Portout from "./views/base/Portout";

import TelitSimInfoForm from "./views/Telit/SimInfo/SimInfoForm";
import TelitSimInfoBatch from "./views/Telit/SimInfo/SimInfoBatch";
import AdminRoutes from "../routes/AdminRoutes";

import ClientActivateForm from "./views/Client/Activate/ActivateForm";
import ClientPartnerActivateForm from "./views/Client/Activate/ClientPartnerActivateForm";
import ClientActivateBatch from "./views/Client/Activate/ActivateBatch";
import ClientDeactivateForm from "./views/Client/Deactivate/DeactivateForm";
import ClientDeactivateBatch from "./views/Client/Deactivate/DeactivateBatch";
import ClientChangeNumberForm from "./views/Client/ChangeNumber/ChangeNumberForm";
import ClientChangeNumberBatch from "./views/Client/ChangeNumber/ChangeNumberBatch";

import User from "./views/User/User";
import UserUpdate from "./views/User/UserUpdate";
import UserCreate from "./views/User/UserCreate";
import HistoryForm from "./views/User/HistoryForm";

import ClientSimInfoForm from "./views/Client/SimInfo/SimInfoForm";
import ClientSimInfoBatch from "./views/Client/SimInfo/SimInfoBatch";
import ClientSimInfo from "./views/Client/SimInfo/SimInfo";

import ResetForm from "./views/Reset/ResetForm";
import ResetBatch from "./views/Reset/ResetBatch";
import ResetBatchList from "./views/Reset/ResetBatchList";

import TMobileCredentialForm from "./views/TMobile/CredentialForm";
import TMobileActivateForm from "./views/TMobile/Activate/ActivateForm";
import TMobileActivateBatch from "./views/TMobile/Activate/ActivateBatch";
import TMobileActivateHistory from "./views/TMobile/Activate/ActivateHistory";

import SelectelSimInfoBatch from "./views/Selectel/SimInfo/SimInfoBatch";
import SelectelSimInfoForm from "./views/Selectel/SimInfo/SimInfoForm";
import SelectelCredentialForm from "./views/Selectel/CredentialForm";

import Hotline from "./views/base/Hotline";
import HotlineForm from "./views/Selectel/Hotline/HotlineForm";
import HotlineHistory from "./views/Selectel/Hotline/HotlineHistory";
import HotlineBatch from "./views/Selectel/Hotline/HotlineBatch";

import WifiCallingForm from "./views/Ultra/WifiCalling/WifiCallingForm";
import WifiCallingBatch from "./views/Ultra/WifiCalling/WifiCallingBatch";
import WifiCallingHistory from "./views/Ultra/WifiCalling/WifiCallingHistory";
import WifiCallingBatchList from "./views/Ultra/WifiCalling/WifiCallingBatchList";
import IMSIBatchList from "./views/Sparq/IMSI/IMSIBatchList";
import IMSIForm from "./views/Sparq/IMSI/IMSIForm";
import IMSIHistory from "./views/Sparq/IMSI/IMSIHistory";
import IMSIBatch from "./views/Sparq/IMSI/IMSIBatch";

import SelectelChangeNumberForm from "./views/Selectel/ChangeNumber/ChangeNumberForm";
import SelectelChangeNumberHistory from "./views/Selectel/ChangeNumber/ChangeNumberHistory";
import SelectelChangeNumberBatch from "./views/Selectel/ChangeNumber/ChangeNumberBatch";
import SelectelChangeSimForm from "./views/Selectel/ChangeSim/ChangeSimForm";
import SelectelChangeSimHistory from "./views/Selectel/ChangeSim/ChangeSimHistory";
import SelectelChangeSimBatch from "./views/Selectel/ChangeSim/ChangeSimBatch";
import SelectelPauseForm from "./views/Selectel/Pause/PauseForm";
import SelectelPauseHistory from "./views/Selectel/Pause/PauseHistory";
import SelectelPauseBatch from "./views/Selectel/Pause/PauseBatch";
import SelectelUnpauseForm from "./views/Selectel/Unpause/UnpauseForm";
import SelectelUnpauseHistory from "./views/Selectel/Unpause/UnpauseHistory";
import SelectelUnpauseBatch from "./views/Selectel/Unpause/UnpauseBatch";

import IMSIStatusBatches from "./views/Sparq/IMSIStatus/IMSIStatusBatches";
import IMSIStatusForm from "./views/Sparq/IMSIStatus/IMSIStatusForm";
import IMSIStatus from "./views/Sparq/IMSIStatus/IMSIStatus";
import IMSIResetBatch from "./views/Sparq/IMSIReset/IMSIResetBatch";
import IMSIResetForm from "./views/Sparq/IMSIReset/IMSIResetForm";
import IMSIResetBatchList from "./views/Sparq/IMSIReset/IMSIResetBatchList";

import OPNSimInfoForm from "./views/OPN/SimInfo/SimInfoForm";
import OPNSimInfoBatch from "./views/OPN/SimInfo/SimInfoBatch";
import OPNCredentialForm from "./views/OPN/CredentialForm";
import OPNRefillForm from "./views/OPN/Refill/RefillForm";
import OPNRefillBatch from "./views/OPN/Refill/RefillBatch";
import OPNRefillHistory from "./views/OPN/Refill/RefillHistory";
import OPNActivateForm from "./views/OPN/Activate/ActivateForm";
import OPNActivateHistory from "./views/OPN/Activate/ActivateHistory";
import OPNActivateBatch from "./views/OPN/Activate/ActivateBatch";
import OPNDeactivateForm from "./views/OPN/Deactivate/DeactivateForm";
import OPNDeactivateBatch from "./views/OPN/Deactivate/DeactivateBatch";
import OPNDeactivateHistory from "./views/OPN/Deactivate/DeactivateHistory";
import IMSIWorkflowForm from "./views/Ultra/IMSIWorkflow/IMSIWorkflowForm";
import IMSIWorkflowBatch from "./views/Ultra/IMSIWorkflow/IMSIWorkflowBatch";
import IMSIWorkflow from "./views/base/IMSIWorkflow";
import IMSIWorkflowHistory from "./views/Ultra/IMSIWorkflow/IMSIWorkflowHistory";

import UltraChangeSimForm from "./views/Ultra/ChangeSim/ChangeSimForm";
import UltraChangeSimHistory from "./views/Ultra/ChangeSim/ChangeSimHistory";
import UltraChangeSimBatch from "./views/Ultra/ChangeSim/ChangeSimBatch";
import TmobilejCredentialForm from "./views/Tmobilej/CredentialForm";
import TmobilejSimInfoBatch from "./views/Tmobilej/SimInfo/SimInfoBatch";
import TmobilejSimInfoForm from "./views/Tmobilej/SimInfo/SimInfoForm";
import TmobilejActivateForm from "./views/Tmobilej/Activate/ActivateForm";
import TmobilejCreateSipCustomerForm from "./views/Tmobilej/Activate/CreateSipCustomerForm";
import TmobilejActivateHistory from "./views/Tmobilej/Activate/ActivateHistory";
import TmobilejActivateBatch from "./views/Tmobilej/Activate/ActivateBatch";
import TmobilejPortinList from "./views/Tmobilej/Portin/PortinList";
import TmobilejPortinForm from "./views/Tmobilej/Portin/PortinForm";
import TmobilejPortinBatch from "./views/Tmobilej/Portin/PortinBatch";
import TmobilejPortinHistory from "./views/Tmobilej/Portin/PortinHistory";
import TmobilejUpdateNumberForm from "./views/Tmobilej/UpdateNumber/UpdateNumberForm";
import TmobilejUpdateNumberBatch from "./views/Tmobilej/UpdateNumber/UpdateNumberBatch";
import TmobilejUpdateNumberHistory from "./views/Tmobilej/UpdateNumber/UpdateNumberHistory";

import TmobilejOrderInfoForm from "./views/Tmobilej/OrderInfo/OrderInfoForm";
import TmobilejOrderInfoHistory from "./views/Tmobilej/OrderInfo/OrderInfoHistory";
import TmobilejOrderInfoBatch from "./views/Tmobilej/OrderInfo/OrderInfoBatch";
import OrderInfo from "./views/base/OrderInfo";

import TmobilejChangeNumberForm from "./views/Tmobilej/ChangeNumber/ChangeNumberForm";
import TmobilejChangeNumberBatch from "./views/Tmobilej/ChangeNumber/ChangeNumberBatch";
import TmobilejChangeNumberHistory from "./views/Tmobilej/ChangeNumber/ChangeNumberHistory";
import TmobilejChangeSimForm from "./views/Tmobilej/ChangeSim/ChangeSimForm";
import TmobilejChangeSimHistory from "./views/Tmobilej/ChangeSim/ChangeSimHistory";
import TmobilejChangeSimBatch from "./views/Tmobilej/ChangeSim/ChangeSimBatch";
import TmobilejDeactivateForm from "./views/Tmobilej/Deactivate/DeactivateForm";
import TmobilejDeactivateBatch from "./views/Tmobilej/Deactivate/DeactivateBatch";
import TmobilejDeactivateHistory from "./views/Tmobilej/Deactivate/DeactivateHistory";
import TmobilejPauseForm from "./views/Tmobilej/Pause/PauseForm";
import TmobilejPauseBatch from "./views/Tmobilej/Pause/PauseBatch";
import TmobilejPauseHistory from "./views/Tmobilej/Pause/PauseHistory";
import TmobilejUnpauseForm from "./views/Tmobilej/Unpause/UnpauseForm";
import TmobilejUnpauseBatch from "./views/Tmobilej/Unpause/UnpauseBatch";
import TmobilejUnpauseHistory from "./views/Tmobilej/Unpause/UnpauseHistory";
import TmobilejFilters from "./views/Tmobilej/Filters/Filters";
import BulkAssignFilterGroups from "./views/Tmobilej/Filters/BulkAssignFilterGroups";
import TmobilejFilterGroupAssign from "./views/Tmobilej/FilterGroupAssign/FilterGroupAssign";
import TmobilejFilterGroupAssignBatch from "./views/Tmobilej/FilterGroupAssign/FilterGroupAssignBatch";
import TmobilejFilterGroupAssignHistory from "./views/Tmobilej/FilterGroupAssign/FilterGroupAssignHistory";

import Plan from "./views/Tmobilej/Plan/Plan";
import PlanCreate from "./views/Tmobilej/Plan/PlanCreate";
import PlanUpdate from "./views/Tmobilej/Plan/PlanUpdate";

import VSSimInfo from "./views/VS/SimInfo/SimInfo";
import VSSimInfoForm from "./views/VS/SimInfo/SimInfoForm";
import VSSimInfoBatch from "./views/VS/SimInfo/SimInfoBatch";
import VSExportList from "./views/VS/SimInfo/VSExportList";
import VSCredentialForm from "./views/VS/CredentialForm";

import NyxSimInfo from "./views/Nyx/SimInfo/SimInfo";
import NyxSimInfoForm from "./views/Nyx/SimInfo/SimInfoForm";
import NyxSimInfoBatch from "./views/Nyx/SimInfo/SimInfoBatch";
import NyxCredentialForm from "./views/Nyx/CredentialForm";
import NyxActivateForm from "./views/Nyx/Activate/ActivateForm";
import NyxActivateBatch from "./views/Nyx/Activate/ActivateBatch";
import NyxActivateHistory from "./views/Nyx/Activate/ActivateHistory";
import NyxDeactivateForm from "./views/Nyx/Deactivate/DeactivateForm";
import NyxDeactivateBatch from "./views/Nyx/Deactivate/DeactivateBatch";
import NyxDeactivateHistory from "./views/Nyx/Deactivate/DeactivateHistory";
import VSUpdateNumberForm from "./views/VS/UpdateNumber/UpdateNumberForm";
import VSUpdateNumberBatch from "./views/VS/UpdateNumber/UpdateNumberBatch";
import VSUpdateNumberHistory from "./views/VS/UpdateNumber/UpdateNumberHistory";
import VSPortinForm from "./views/VS/Portin/PortinForm";
import VSPortinBatch from "./views/VS/Portin/PortinBatch";
import VSPortinHistory from "./views/VS/Portin/PortinHistory";

import ITActivateForm from "./views/IT/Activate/ActivateForm";
import ITActivateBatch from "./views/IT/Activate/ActivateBatch";
import ITActivateHistory from "./views/IT/Activate/ActivateHistory";
import ITChangeNumberForm from "./views/IT/ChangeNumber/ChangeNumberForm";
import ITChangeNumberBatch from "./views/IT/ChangeNumber/ChangeNumberBatch";
import ITChangeNumberHistory from "./views/IT/ChangeNumber/ChangeNumberHistory";
import ITChangeSimForm from "./views/IT/ChangeSim/ChangeSimForm";
import ITChangeSimBatch from "./views/IT/ChangeSim/ChangeSimBatch";
import ITChangeSimHistory from "./views/IT/ChangeSim/ChangeSimHistory";
import ITRefillForm from "./views/IT/Refill/RefillForm";
import ITRefillBatch from "./views/IT/Refill/RefillBatch";
import ITRefillHistory from "./views/IT/Refill/RefillHistory";
import ITPortoutForm from "./views/IT/Portout/PortoutForm";
import ITPortoutBatch from "./views/IT/Portout/PortoutBatch";
import ITPortoutHistory from "./views/IT/Portout/PortoutHistory";
import ITSimInfoForm from "./views/IT/SimInfo/SimInfoForm";
import ITSimInfoBatch from "./views/IT/SimInfo/SimInfoBatch";
import ITCredentialForm from "./views/IT/CredentialForm";

import UpdateNumber from "./views/base/UpdateNumber";

function App() {
  const [auth, authDispatch] = useReducer(authReducer, initialAuth);
  const [alert, alertDispatch] = useReducer(alertReducer, initialAlert);
  const [isLoading, loadingDispatch] = useReducer(
    loadingReducer,
    initialLoading
  );
  return (
    <BrowserRouter>
      <AuthContext.Provider value={[auth, authDispatch]}>
        <AlertContext.Provider value={[alert, alertDispatch]}>
          <LoadingContext.Provider value={[isLoading, loadingDispatch]}>
            <AlertBox />
            <LoadingBox />
            <Routes>
              <Route path="/login" exact element={<Login />} />
              <Route path="/" element={<PrivateRoute />}>
                <Route index element={<Home />} />

                <Route path="/" element={<AdminRoutes />}>
                  <Route path="/ultra">
                    <Route index element={<Navigate to="activate" />} />
                    <Route path="credential" element={<CredentialForm />} />
                    <Route path="activate">
                      <Route
                        index
                        element={
                          <Activate
                            key={CLIENTS.ultra}
                            client={CLIENTS.ultra}
                          />
                        }
                      />
                      <Route path="form" element={<ActivateForm />} />
                      <Route
                        path=":activate_id"
                        element={<ActivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<ActivateBatch />}
                      />
                      <Route
                        path="batch/:batch_id/update"
                        element={<ActivateUpdate />}
                      />
                    </Route>
                    <Route path="deactivate">
                      <Route
                        index
                        element={
                          <Deactivate
                            key={CLIENTS.ultra}
                            client={CLIENTS.ultra}
                          />
                        }
                      />
                      <Route path="form" element={<DeactivateForm />} />
                      <Route
                        path=":deactivate_id"
                        element={<DeactivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<DeactivateBatch />}
                      />
                    </Route>
                    <Route path="change_number">
                      <Route
                        index
                        element={
                          <ChangeNumber
                            key={CLIENTS.ultra}
                            client={CLIENTS.ultra}
                          />
                        }
                      />
                      <Route path="form" element={<ChangeNumberForm />} />
                      <Route
                        path=":change_number_id"
                        element={<ChangeNumberHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<ChangeNumberBatch />}
                      />
                      <Route
                        path="batch/:batch_id/update"
                        element={<ChangeNumberUpdate />}
                      />
                    </Route>
                    <Route path="change_plan">
                      <Route
                        index
                        element={
                          <ChangePlan
                            key={CLIENTS.ultra}
                            client={CLIENTS.ultra}
                          />
                        }
                      />
                      <Route path="form" element={<ChangePlanForm />} />
                      <Route
                        path=":change_plan_id"
                        element={<ChangePlanHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<ChangePlanBatch />}
                      />
                    </Route>
                    <Route path="pause">
                      <Route
                        index
                        element={
                          <Pause key={CLIENTS.ultra} client={CLIENTS.ultra} />
                        }
                      />
                      <Route path="form" element={<PauseForm />} />
                      <Route path=":pause_id" element={<PauseHistory />} />
                      <Route path="batch/:batch_id" element={<PauseBatch />} />
                    </Route>
                    <Route path="deactivate">
                      <Route
                        index
                        element={
                          <Deactivate
                            client={CLIENTS.ultra}
                            key={CLIENTS.ultra}
                          />
                        }
                      />
                      <Route path="form" element={<DeactivateForm />} />
                      <Route
                        path=":deactivate_id"
                        element={<DeactivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<DeactivateBatch />}
                      />
                    </Route>
                    <Route path="unpause">
                      <Route
                        index
                        element={
                          <Unpause key={CLIENTS.ultra} client={CLIENTS.ultra} />
                        }
                      />
                      <Route path="form" element={<UnpauseForm />} />
                      <Route path=":unpause_id" element={<UnpauseHistory />} />
                      <Route
                        path="batch/:batch_id"
                        element={<UnpauseBatch />}
                      />
                    </Route>
                    <Route path="restore">
                      <Route
                        index
                        element={
                          <Restore key={CLIENTS.ultra} client={CLIENTS.ultra} />
                        }
                      />
                      <Route path="form" element={<RestoreForm />} />
                      <Route path=":restore_id" element={<RestoreHistory />} />
                      <Route
                        path="batch/:batch_id"
                        element={<RestoreBatch />}
                      />
                    </Route>
                    <Route path="sim_info">
                      <Route
                        index
                        element={<SimInfo client={CLIENTS.ultra} />}
                      />
                      <Route path="form" element={<SimInfoForm />} />
                      <Route
                        path="batch/:batch_id"
                        element={<SimInfoBatch />}
                      />
                      <Route path="zip" element={<ZipCheckList />} />
                      <Route path="zip/form" element={<ZipCheckForm />} />
                    </Route>
                    <Route path="portin">
                      <Route
                        index
                        element={
                          <Portin key={CLIENTS.ultra} client={CLIENTS.ultra} />
                        }
                      />
                      <Route path="form" element={<PortinForm />} />
                      <Route path=":portin_id" element={<PortinHistory />} />
                      <Route path="batch/:batch_id" element={<PortinBatch />} />
                    </Route>
                    <Route path="wifi_calling">
                      <Route
                        index
                        element={
                          <WifiCallingBatchList
                            key={CLIENTS.ultra}
                            client={CLIENTS.ultra}
                          />
                        }
                      />
                      <Route path="form" element={<WifiCallingForm />} />
                      <Route
                        path=":wificalling_id"
                        element={<WifiCallingHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<WifiCallingBatch />}
                      />
                    </Route>
                    <Route path="reset">
                      <Route
                        index
                        element={
                          <ResetBatchList
                            key={CLIENTS.ultra}
                            client={CLIENTS.ultra}
                            isClient={false}
                          />
                        }
                      />
                      <Route
                        path="form"
                        element={
                          <ResetForm
                            key={CLIENTS.ultra}
                            client={CLIENTS.ultra}
                            isClient={false}
                          />
                        }
                      />
                      <Route path="batch/:batch_id" element={<ResetBatch />} />
                    </Route>
                    <Route path="esim">
                      <Route index element={<UltraEsim />} />
                      <Route path="form" element={<EsimForm />} />
                    </Route>
                    <Route path="imsi_workflow">
                      <Route
                        index
                        element={
                          <IMSIWorkflow
                            key={CLIENTS.ultra}
                            client={CLIENTS.ultra}
                          />
                        }
                      />
                      <Route path="form" element={<IMSIWorkflowForm />} />
                      <Route
                        path=":imsi_workflow_id"
                        element={<IMSIWorkflowHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<IMSIWorkflowBatch />}
                      />
                    </Route>
                    <Route path="change_sim">
                      <Route
                        index
                        element={
                          <ChangeSimBatchList
                            client={CLIENTS.ultra}
                            key={CLIENTS.ultra}
                          />
                        }
                      />
                      <Route path="form" element={<UltraChangeSimForm />} />
                      <Route
                        path=":change_sim_id"
                        element={<UltraChangeSimHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<UltraChangeSimBatch />}
                      />
                    </Route>
                  </Route>

                  <Route path="/telit">
                    <Route index element={<Navigate to="activate" />} />
                    <Route
                      path="credential"
                      element={<TelitCredentialForm />}
                    />
                    <Route path="activate">
                      <Route
                        index
                        element={
                          <Activate
                            client={CLIENTS.telit}
                            key={CLIENTS.telit}
                          />
                        }
                      />
                      <Route path="form" element={<TelitActivateForm />} />
                      <Route
                        path=":activate_id"
                        element={<TelitActivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<TelitActivateBatch />}
                      />
                    </Route>
                    <Route path="deactivate">
                      <Route
                        index
                        element={
                          <Deactivate
                            client={CLIENTS.telit}
                            key={CLIENTS.telit}
                          />
                        }
                      />
                      <Route path="form" element={<TelitDeactivateForm />} />
                      <Route
                        path=":deactivate_id"
                        element={<TelitDeactivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<TelitDeactivateBatch />}
                      />
                    </Route>
                    <Route path="change_number">
                      <Route
                        index
                        element={
                          <ChangeNumber
                            client={CLIENTS.telit}
                            key={CLIENTS.telit}
                          />
                        }
                      />
                      <Route path="form" element={<TelitChangeNumberForm />} />
                      <Route
                        path=":change_number_id"
                        element={<TelitChangeNumberHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<TelitChangeNumberBatch />}
                      />
                    </Route>
                    <Route path="change_plan">
                      <Route
                        index
                        element={
                          <ChangePlan
                            client={CLIENTS.telit}
                            key={CLIENTS.telit}
                          />
                        }
                      />
                      <Route path="form" element={<TelitChangePlanForm />} />
                      <Route
                        path=":change_plan_id"
                        element={<TelitChangePlanHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<TelitChangePlanBatch />}
                      />
                    </Route>
                    <Route path="pause">
                      <Route
                        index
                        element={
                          <Pause client={CLIENTS.telit} key={CLIENTS.telit} />
                        }
                      />
                      <Route path="form" element={<TelitPauseForm />} />
                      <Route path=":pause_id" element={<TelitPauseHistory />} />
                      <Route
                        path="batch/:batch_id"
                        element={<TelitPauseBatch />}
                      />
                    </Route>
                    <Route path="deactivate">
                      <Route
                        index
                        element={
                          <Deactivate
                            client={CLIENTS.telit}
                            key={CLIENTS.telit}
                          />
                        }
                      />
                      <Route path="form" element={<TelitDeactivateForm />} />
                      <Route
                        path=":deactivate_id"
                        element={<TelitDeactivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<TelitDeactivateBatch />}
                      />
                    </Route>
                    <Route path="sim_info">
                      <Route
                        index
                        element={<SimInfo client={CLIENTS.telit} />}
                      />
                      <Route path="form" element={<TelitSimInfoForm />} />
                      <Route
                        path="batch/:batch_id"
                        element={<TelitSimInfoBatch />}
                      />
                      <Route path="export" element={<TelitExportList />} />
                    </Route>
                    <Route path="reset">
                      <Route
                        index
                        element={
                          <ResetBatchList
                            key={CLIENTS.telit}
                            client={CLIENTS.telit}
                            isClient={false}
                          />
                        }
                      />
                      <Route
                        path="form"
                        element={
                          <ResetForm
                            key={CLIENTS.ultra}
                            client={CLIENTS.telit}
                            isClient={false}
                          />
                        }
                      />
                      <Route path="batch/:batch_id" element={<ResetBatch />} />
                    </Route>
                  </Route>

                  <Route path="/sparq">
                    <Route index element={<Navigate to="activate" />} />
                    <Route
                      path="credential"
                      element={<SparqCredentialForm />}
                    />
                    <Route path="activate">
                      <Route
                        index
                        element={
                          <Activate
                            client={CLIENTS.sparq}
                            key={CLIENTS.sparq}
                          />
                        }
                      />
                      <Route path="form" element={<SparqActivateForm />} />
                      <Route
                        path=":activate_id"
                        element={<SparqActivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<SparqActivateBatch />}
                      />
                    </Route>
                    <Route path="deactivate">
                      <Route
                        index
                        element={
                          <Deactivate
                            client={CLIENTS.sparq}
                            key={CLIENTS.sparq}
                          />
                        }
                      />
                      <Route path="form" element={<SparqDeactivateForm />} />
                      <Route
                        path=":deactivate_id"
                        element={<SparqDeactivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<SparqDeactivateBatch />}
                      />
                    </Route>

                    <Route path="imsi">
                      <Route
                        path="imsi_create"
                        element={
                          <IMSIBatchList
                            client={CLIENTS.sparq}
                            key={OPERATIONS.imsi_create}
                            operation={OPERATIONS.imsi_create}
                          />
                        }
                      />
                      <Route
                        path="imsi_create/form"
                        element={
                          <IMSIForm
                            key={OPERATIONS.imsi_create}
                            operation={OPERATIONS.imsi_create}
                          />
                        }
                      />
                      <Route
                        path="imsi_create/batch/:batch_id"
                        element={
                          <IMSIBatch
                            key={OPERATIONS.imsi_create}
                            operation={OPERATIONS.imsi_create}
                          />
                        }
                      />
                      <Route
                        path="imsi_create/:imsi_id"
                        element={
                          <IMSIHistory
                            key={OPERATIONS.imsi_create}
                            operation={OPERATIONS.imsi_create}
                          />
                        }
                      />
                      <Route
                        path="imsi_delete"
                        element={
                          <IMSIBatchList
                            client={CLIENTS.sparq}
                            key={OPERATIONS.imsi_delete}
                            operation={OPERATIONS.imsi_delete}
                          />
                        }
                      />
                      <Route
                        path="imsi_delete/form"
                        element={
                          <IMSIForm
                            key={OPERATIONS.imsi_delete}
                            operation={OPERATIONS.imsi_delete}
                          />
                        }
                      />
                      <Route
                        path="imsi_delete/batch/:batch_id"
                        element={
                          <IMSIBatch
                            key={OPERATIONS.imsi_delete}
                            operation={OPERATIONS.imsi_delete}
                          />
                        }
                      />
                      <Route
                        path="imsi_delete/:imsi_id"
                        element={
                          <IMSIHistory
                            key={OPERATIONS.imsi_delete}
                            operation={OPERATIONS.imsi_delete}
                          />
                        }
                      />
                    </Route>

                    <Route path="imsi_status">
                      <Route
                        index
                        element={
                          <IMSIStatus
                            client={CLIENTS.imsi}
                            key={OPERATIONS.sim_info}
                            operation={OPERATIONS.sim_info}
                          />
                        }
                      />
                      <Route
                        path="form"
                        element={
                          <IMSIStatusForm
                            key={OPERATIONS.sim_info}
                            operation={OPERATIONS.sim_info}
                          />
                        }
                      />
                      <Route
                        path="batch/:batch_id"
                        element={
                          <IMSIStatusBatches
                            key={OPERATIONS.sim_info}
                            operation={OPERATIONS.sim_info}
                          />
                        }
                      />
                    </Route>

                    <Route path="imsi_reset">
                      <Route
                        index
                        element={
                          <IMSIResetBatchList
                            client={CLIENTS.imsi}
                            key={OPERATIONS.reset}
                            operation={OPERATIONS.reset}
                          />
                        }
                      />
                      <Route
                        path="form"
                        element={
                          <IMSIResetForm
                            key={OPERATIONS.reset}
                            operation={OPERATIONS.reset}
                          />
                        }
                      />
                      <Route
                        path="batch/:batch_id"
                        element={
                          <IMSIResetBatch
                            key={OPERATIONS.reset}
                            operation={OPERATIONS.reset}
                          />
                        }
                      />
                    </Route>
                  </Route>

                  <Route path="/cricket">
                    <Route index element={<Navigate to="activate" />} />
                    <Route
                      path="credential"
                      element={<CricketCredentialForm />}
                    />
                    <Route path="activate">
                      <Route
                        index
                        element={
                          <Activate
                            client={CLIENTS.cricket}
                            key={CLIENTS.cricket}
                          />
                        }
                      />
                      <Route path="form" element={<CricketActivateForm />} />
                      <Route
                        path=":activate_id"
                        element={<CricketActivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<CricketActivateBatch />}
                      />
                    </Route>
                    <Route path="refill">
                      <Route
                        index
                        element={
                          <Refill
                            client={CLIENTS.cricket}
                            key={CLIENTS.cricket}
                          />
                        }
                      />
                      <Route path="form" element={<CricketRefillForm />} />
                      <Route
                        path=":refill_id"
                        element={<CricketRefillHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<CricketRefillBatch />}
                      />
                    </Route>
                  </Route>

                  <Route path="/verizon">
                    <Route
                      index
                      element={<Navigate to="activate" key={CLIENTS.verizon} />}
                    />
                    <Route
                      path="credential"
                      element={<VerizonCredentialForm />}
                    />
                    <Route path="activate">
                      <Route
                        index
                        element={<Activate client={CLIENTS.verizon} />}
                      />
                      <Route path="form" element={<VerizonActivateForm />} />
                      <Route
                        path=":activate_id"
                        element={<VerizonActivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<VerizonActivateBatch />}
                      />
                    </Route>
                    <Route path="refill">
                      <Route
                        index
                        element={
                          <Refill
                            client={CLIENTS.verizon}
                            key={CLIENTS.verizon}
                          />
                        }
                      />
                      <Route path="form" element={<VerizonRefillForm />} />
                      <Route
                        path=":refill_id"
                        element={<VerizonRefillHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<VerizonRefillBatch />}
                      />
                    </Route>
                  </Route>
                  <Route path="/tmobile">
                    <Route
                      index
                      element={<Navigate to="activate" key={CLIENTS.tmobile} />}
                    />
                    <Route
                      path="credential"
                      element={<TMobileCredentialForm />}
                    />
                    <Route path="activate">
                      <Route
                        index
                        element={<Activate client={CLIENTS.tmobile} />}
                      />
                      <Route path="form" element={<TMobileActivateForm />} />
                      <Route
                        path=":activate_id"
                        element={<TMobileActivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<TMobileActivateBatch />}
                      />
                    </Route>
                  </Route>
                  <Route path="/selectel">
                    <Route path="hotline">
                      <Route
                        index
                        element={
                          <Hotline
                            key={CLIENTS.selectel}
                            client={CLIENTS.selectel}
                          />
                        }
                      />
                      <Route path="form" element={<HotlineForm />} />
                      <Route path=":hotline_id" element={<HotlineHistory />} />
                      <Route
                        path="batch/:batch_id"
                        element={<HotlineBatch />}
                      />
                    </Route>
                    <Route path="change_number">
                      <Route
                        index
                        element={
                          <ChangeNumber
                            client={CLIENTS.selectel}
                            key={CLIENTS.selectel}
                          />
                        }
                      />
                      <Route
                        path="form"
                        element={<SelectelChangeNumberForm />}
                      />
                      <Route
                        path=":change_number_id"
                        element={<SelectelChangeNumberHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<SelectelChangeNumberBatch />}
                      />
                    </Route>
                    <Route path="change_sim">
                      <Route
                        index
                        element={
                          <ChangeSimBatchList
                            client={CLIENTS.selectel}
                            key={CLIENTS.selectel}
                          />
                        }
                      />

                      <Route path="form" element={<SelectelChangeSimForm />} />
                      <Route
                        path=":change_sim_id"
                        element={<SelectelChangeSimHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<SelectelChangeSimBatch />}
                      />
                    </Route>
                    <Route path="pause">
                      <Route
                        index
                        element={
                          <Pause
                            client={CLIENTS.selectel}
                            key={CLIENTS.selectel}
                          />
                        }
                      />
                      <Route path="form" element={<SelectelPauseForm />} />
                      <Route
                        path=":pause_id"
                        element={<SelectelPauseHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<SelectelPauseBatch />}
                      />
                    </Route>
                    <Route path="unpause">
                      <Route
                        index
                        element={
                          <Unpause
                            client={CLIENTS.selectel}
                            key={CLIENTS.selectel}
                          />
                        }
                      />
                      <Route path="form" element={<SelectelUnpauseForm />} />
                      <Route
                        path=":unpause_id"
                        element={<SelectelUnpauseHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<SelectelUnpauseBatch />}
                      />
                    </Route>
                    <Route
                      path="credential"
                      element={<SelectelCredentialForm />}
                    />
                    <Route path="sim_info">
                      <Route
                        index
                        element={<SimInfo client={CLIENTS.selectel} />}
                      />
                      <Route path="form" element={<SelectelSimInfoForm />} />
                      <Route
                        path="batch/:batch_id"
                        element={<SelectelSimInfoBatch />}
                      />
                    </Route>
                  </Route>
                  <Route path="/opn">
                    <Route index element={<Navigate to="sim_info" />} />
                    <Route path="sim_info">
                      <Route index element={<SimInfo client={CLIENTS.opn} />} />
                      <Route path="form" element={<OPNSimInfoForm />} />
                      <Route
                        path="batch/:batch_id"
                        element={<OPNSimInfoBatch />}
                      />
                    </Route>
                    <Route path="activate">
                      <Route
                        index
                        element={
                          <Activate client={CLIENTS.opn} key={CLIENTS.opn} />
                        }
                      />
                      <Route path="form" element={<OPNActivateForm />} />
                      <Route
                        path=":activate_id"
                        element={<OPNActivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<OPNActivateBatch />}
                      />
                    </Route>
                    <Route path="refill">
                      <Route index element={<Refill client={CLIENTS.opn} />} />
                      <Route path="form" element={<OPNRefillForm />} />
                      <Route
                        path="batch/:batch_id"
                        element={<OPNRefillBatch />}
                      />
                      <Route path=":refill_id" element={<OPNRefillHistory />} />
                    </Route>
                    <Route path="deactivate">
                      <Route
                        index
                        element={
                          <Deactivate client={CLIENTS.opn} key={CLIENTS.opn} />
                        }
                      />
                      <Route path="form" element={<OPNDeactivateForm />} />
                      <Route
                        path=":deactivate_id"
                        element={<OPNDeactivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<OPNDeactivateBatch />}
                      />
                    </Route>
                    <Route path="credential" element={<OPNCredentialForm />} />
                  </Route>

                  <Route path="/tmobilej">
                    <Route index element={<Navigate to="activate" />} />
                    <Route path="activate">
                      <Route
                        index
                        element={
                          <Activate
                            client={CLIENTS.tmobilej}
                            key={CLIENTS.tmobilej}
                            showCreateSipCustomer
                          />
                        }
                      />
                      <Route path="form" element={<TmobilejActivateForm />} />
                      <Route
                        path="sip-customer-form"
                        element={<TmobilejCreateSipCustomerForm />}
                      />
                      <Route
                        path=":activate_id"
                        element={<TmobilejActivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<TmobilejActivateBatch />}
                      />
                    </Route>
                    <Route path="update_number">
                    <Route
                        index
                        element={
                          <UpdateNumber
                            client={CLIENTS.tmobilej}
                            key={CLIENTS.tmobilej}
                          />
                        }
                      />
                      <Route path="form" element={<TmobilejUpdateNumberForm />} />
                      <Route path="batch/:batch_id" element={<TmobilejUpdateNumberBatch />} />
                      <Route path=":update_number_id" element={<TmobilejUpdateNumberHistory />} />
                    </Route>
                    <Route path="change_number">
                      <Route
                        index
                        element={
                          <ChangeNumber
                            client={CLIENTS.tmobilej}
                            key={CLIENTS.tmobilej}
                          />
                        }
                      />
                      <Route path="form" element={<TmobilejChangeNumberForm />} />
                      <Route
                        path=":change_number_id"
                        element={<TmobilejChangeNumberHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<TmobilejChangeNumberBatch />}
                      />
                    </Route>
                    <Route path="change_sim">
                      <Route
                        index
                        element={
                          <ChangeSimBatchList
                            client={CLIENTS.tmobilej}
                            key={`${CLIENTS.tmobilej}-change_sim`}
                          />
                        }
                      />
                      <Route path="form" element={<TmobilejChangeSimForm />} />
                      <Route
                        path=":change_sim_id"
                        element={<TmobilejChangeSimHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<TmobilejChangeSimBatch />}
                      />
                    </Route>
                    <Route path="deactivate">
                      <Route
                        index
                        element={
                          <Deactivate
                            client={CLIENTS.tmobilej}
                            key={CLIENTS.tmobilej}
                          />
                        }
                      />
                      <Route path="form" element={<TmobilejDeactivateForm />} />
                      <Route
                        path=":deactivate_id"
                        element={<TmobilejDeactivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<TmobilejDeactivateBatch />}
                      />
                    </Route>
                    <Route path="pause">
                      <Route
                        index
                        element={
                          <Pause
                            client={CLIENTS.tmobilej}
                            key={CLIENTS.tmobilej}
                          />
                        }
                      />
                      <Route path="form" element={<TmobilejPauseForm />} />
                      <Route path=":pause_id" element={<TmobilejPauseHistory />} />
                      <Route
                        path="batch/:batch_id"
                        element={<TmobilejPauseBatch />}
                      />
                    </Route>
                    <Route path="unpause">
                      <Route
                        index
                        element={
                          <Unpause
                            client={CLIENTS.tmobilej}
                            key={CLIENTS.tmobilej}
                          />
                        }
                      />
                      <Route path="form" element={<TmobilejUnpauseForm />} />
                      <Route
                        path=":unpause_id"
                        element={<TmobilejUnpauseHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<TmobilejUnpauseBatch />}
                      />
                    </Route>
                    <Route path="portin">
                      <Route
                        index
                        element={
                          <Portin
                            client={CLIENTS.tmobilej}
                            key={CLIENTS.tmobilej}
                          />
                        }
                      />
                      <Route path="form" element={<TmobilejPortinForm />} />
                      <Route path="list" element={<TmobilejPortinList />} />
                      <Route path="batch/:batch_id" element={<TmobilejPortinBatch />} />
                      <Route
                        path=":portin_id"
                        element={<TmobilejPortinHistory />}
                      />
                    </Route>

                    <Route path="order_info">
                      <Route
                        index
                        element={
                          <OrderInfo
                            client={CLIENTS.tmobilej}
                            key={CLIENTS.tmobilej}
                          />
                        }
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<TmobilejOrderInfoBatch />}
                      />
                      <Route path="form" element={<TmobilejOrderInfoForm />} />
                      <Route
                        path=":order_info_id"
                        element={<TmobilejOrderInfoHistory />}
                      />
                    </Route>

                    <Route path="filters" element={<TmobilejFilters />} />
                    <Route path="filter_group_assign">
                      <Route index element={<TmobilejFilterGroupAssign />} />
                      <Route path="form" element={<BulkAssignFilterGroups />} />
                      <Route
                        path="batch/:batch_id"
                        element={<TmobilejFilterGroupAssignBatch />}
                      />
                      <Route
                        path=":assign_id"
                        element={<TmobilejFilterGroupAssignHistory />}
                      />
                    </Route>

                    <Route path="sim_info">
                      <Route
                        index
                        element={
                          <SimInfo
                            client={CLIENTS.tmobilej}
                            key={CLIENTS.tmobilej}
                          />
                        }
                      />
                      <Route path="form" element={<TmobilejSimInfoForm />} />
                      <Route
                        path="batch/:batch_id"
                        element={
                          <TmobilejSimInfoBatch key={CLIENTS.tmobilej} />
                        }
                      />
                      <Route path="export" element={<TmobilejExportList />} />
                    </Route>
                    <Route path="plan">
                      <Route index element={<Plan />} />
                      <Route path=":plan_id" element={<PlanUpdate />} />
                      <Route path="create" element={<PlanCreate />} />
                    </Route>
                    <Route
                      path="credential"
                      element={<TmobilejCredentialForm />}
                    />
                  </Route>

                  <Route path="/vs">
                    <Route index element={<Navigate to="sim_info" />} />
                    <Route path="sim_info">
                      <Route
                        index
                        element={<VSSimInfo />}
                      />
                      <Route path="form" element={<VSSimInfoForm />} />
                      <Route
                        path="batch/:batch_id"
                        element={<VSSimInfoBatch />}
                      />
                      <Route path="export" element={<VSExportList />} />
                    </Route>
                    <Route path="update_number">
                    <Route
                        index
                        element={
                          <UpdateNumber
                            client={CLIENTS.vs}
                            key={CLIENTS.vs}
                          />
                        }
                      />
                      <Route path="form" element={<VSUpdateNumberForm />} />
                      <Route path="batch/:batch_id" element={<VSUpdateNumberBatch />} />
                      <Route path=":update_number_id" element={<VSUpdateNumberHistory />} />
                    </Route>
                    <Route path="portin">
                      <Route
                        index
                        element={
                          <Portin
                            client={CLIENTS.vs}
                            key={CLIENTS.vs}
                          />
                        }
                      />
                      <Route path="form" element={<VSPortinForm />} />
                      <Route path="batch/:batch_id" element={<VSPortinBatch />} />
                      <Route
                        path=":portin_id"
                        element={<VSPortinHistory />}
                      />
                    </Route>
                    <Route
                      path="credential"
                      element={<VSCredentialForm />}
                    />
                  </Route>

                  <Route path="/nyx">
                    <Route index element={<Navigate to="activate" />} />
                    <Route path="credential" element={<NyxCredentialForm />} />
                    <Route path="activate">
                      <Route
                        index
                        element={
                          <Activate
                            key={CLIENTS.nyx}
                            client={CLIENTS.nyx}
                          />
                        }
                      />
                      <Route path="form" element={<NyxActivateForm />} />
                      <Route
                        path=":activate_id"
                        element={<NyxActivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<NyxActivateBatch />}
                      />
                    </Route>
                    <Route path="sim_info">
                      <Route
                        index
                        element={<NyxSimInfo />}
                      />
                      <Route path="form" element={<NyxSimInfoForm />} />
                      <Route
                        path="batch/:batch_id"
                        element={<NyxSimInfoBatch />}
                      />
                    </Route>
                    <Route path="deactivate">
                      <Route
                        index
                        element={
                          <Deactivate
                            key={CLIENTS.nyx}
                            client={CLIENTS.nyx}
                          />
                        }
                      />
                      <Route path="form" element={<NyxDeactivateForm />} />
                      <Route
                        path=":deactivate_id"
                        element={<NyxDeactivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<NyxDeactivateBatch />}
                      />
                    </Route>
                  </Route>

                  <Route path="/it">
                    <Route index element={<Navigate to="activate" />} />
                    <Route path="credential" element={<ITCredentialForm />} />
                    <Route path="activate">
                      <Route
                        index
                        element={
                          <Activate
                            key={CLIENTS.it}
                            client={CLIENTS.it}
                          />
                        }
                      />
                      <Route path="form" element={<ITActivateForm />} />
                      <Route
                        path=":activate_id"
                        element={<ITActivateHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<ITActivateBatch />}
                      />
                    </Route>
                    <Route path="change_number">
                      <Route
                        index
                        element={
                          <ChangeNumber
                            key={CLIENTS.it}
                            client={CLIENTS.it}
                          />
                        }
                      />
                      <Route path="form" element={<ITChangeNumberForm />} />
                      <Route
                        path=":change_number_id"
                        element={<ITChangeNumberHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<ITChangeNumberBatch />}
                      />
                    </Route>
                    <Route path="change_sim">
                      <Route
                        index
                        element={
                          <ChangeSimBatchList
                            client={CLIENTS.it}
                            key={`${CLIENTS.it}-change_sim`}
                          />
                        }
                      />
                      <Route path="form" element={<ITChangeSimForm />} />
                      <Route
                        path=":change_sim_id"
                        element={<ITChangeSimHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<ITChangeSimBatch />}
                      />
                    </Route>
                    <Route path="refill">
                      <Route
                        index
                        element={
                          <Refill
                            key={CLIENTS.it}
                            client={CLIENTS.it}
                          />
                        }
                      />
                      <Route path="form" element={<ITRefillForm />} />
                      <Route
                        path=":refill_id"
                        element={<ITRefillHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<ITRefillBatch />}
                      />
                    </Route>
                    <Route path="portout">
                      <Route
                        index
                        element={
                          <Portout
                            key={CLIENTS.it}
                            client={CLIENTS.it}
                          />
                        }
                      />
                      <Route path="form" element={<ITPortoutForm />} />
                      <Route
                        path=":portout_id"
                        element={<ITPortoutHistory />}
                      />
                      <Route
                        path="batch/:batch_id"
                        element={<ITPortoutBatch />}
                      />
                    </Route>
                    <Route path="sim_info">
                      <Route
                        index
                        element={<SimInfo client={CLIENTS.it} />}
                      />
                      <Route path="form" element={<ITSimInfoForm />} />
                      <Route
                        path="batch/:batch_id"
                        element={<ITSimInfoBatch />}
                      />
                    </Route>
                  </Route>

                  <Route path="/user">
                    <Route index element={<User />} />
                    <Route path=":user_id" element={<UserUpdate />} />
                    <Route path="create" element={<UserCreate />} />
                    <Route path="user_history" element={<HistoryForm />} />
                  </Route>
                </Route>

                {/* {start of client routes} */}
                <Route path="/client">
                  <Route index element={<Navigate to="activate" />} />
                  <Route path="activate">
                    <Route
                      index
                      element={<Activate showVirtualActivation />}
                    />
                    <Route path="form" element={<ClientActivateForm />} />
                    <Route
                      path="virtual-form"
                      element={<ClientPartnerActivateForm />}
                    />
                    <Route
                      path="partner-form"
                      element={<Navigate to="../virtual-form" replace />}
                    />
                    <Route
                      path="batch/:batch_id"
                      element={<ClientActivateBatch />}
                    />
                  </Route>
                  <Route path="deactivate">
                    <Route index element={<Deactivate />} />
                    <Route path="form" element={<ClientDeactivateForm />} />
                    <Route
                      path="batch/:batch_id"
                      element={<ClientDeactivateBatch />}
                    />
                  </Route>
                  <Route path="change_number">
                    <Route index element={<ChangeNumber />} />
                    <Route path="form" element={<ClientChangeNumberForm />} />
                    <Route
                      path="batch/:batch_id"
                      element={<ClientChangeNumberBatch />}
                    />
                  </Route>
                  <Route path="sim_info">
                    <Route index element={<ClientSimInfo />} />
                    <Route path="form" element={<ClientSimInfoForm />} />
                    <Route
                      path="batch/:batch_id"
                      element={<ClientSimInfoBatch />}
                    />
                  </Route>
                  <Route path="reset">
                    <Route index element={<ResetBatchList isClient={true} />} />
                    <Route
                      path="form"
                      element={<ResetForm isClient={true} />}
                    />
                    <Route path="batch/:batch_id" element={<ResetBatch />} />
                  </Route>
                </Route>

                <Route path="*" element={<h1>404 Error!!!</h1>} />
              </Route>
            </Routes>
          </LoadingContext.Provider>
        </AlertContext.Provider>
      </AuthContext.Provider>
    </BrowserRouter>
  );
}

export default App;
